// Dynamic categories - stored in localStorage, editable in UI
export const DEFAULT_CATEGORIES = ['Stödstrumpor', 'Arbetskläder', 'Arbetsskor'];

// Markets with flag emojis
export const MARKETS = ['Sverige', 'Norge', 'Finland', 'Tyskland', 'Danmark', 'Nederländerna'];

export const MARKET_LANGUAGE = {
  Sverige:        { lang: 'svenska',                       instruction: 'Skriv ENBART på svenska.',                                 flag: '🇸🇪' },
  Norge:          { lang: 'norska (bokmål)',               instruction: 'Skriv ENBART på norska (bokmål).',                         flag: '🇳🇴' },
  Finland:        { lang: 'finska',                        instruction: 'Skriv ENBART på finska.',                                  flag: '🇫🇮' },
  Tyskland:       { lang: 'tyska',                         instruction: 'Skriv ENBART på tyska.',                                   flag: '🇩🇪' },
  Danmark:        { lang: 'danska',                        instruction: 'Skriv ENBART på danska.',                                  flag: '🇩🇰' },
  Nederländerna:  { lang: 'nederländska (Nederländerna)',  instruction: 'Skriv ENBART på nederländska som talas i Nederländerna. INTE belgisk nederländska (flamländska).', flag: '🇳🇱' },
};

export const MARKET_FLAGS = {
  // Display name keys (used by new log entries)
  Sverige: '🇸🇪', Norge: '🇳🇴', Finland: '🇫🇮', Tyskland: '🇩🇪', Danmark: '🇩🇰', Nederländerna: '🇳🇱',
  // Legacy code keys (backward compat for older log entries)
  SE: '🇸🇪', NO: '🇳🇴', FI: '🇫🇮', DE: '🇩🇪', DK: '🇩🇰', NL: '🇳🇱',
};

export const MARKET_CODE_TO_DISPLAY = {
  SE: 'Sverige', NO: 'Norge', FI: 'Finland', DE: 'Tyskland', DK: 'Danmark', NL: 'Nederländerna',
};

// LLM-modeller — delas av Inställningar och Newsletter-fliken
export const MODEL_OPTIONS = [
  { value: 'gemini', label: 'Gemini 2.5 Flash',  sub: 'Google Gemini · Standard',  color: '#4f8ef7' },
  { value: 'claude', label: 'Claude Sonnet 4.5', sub: 'Anthropic · Kvalitet',      color: '#d97706' },
  { value: 'gpt4o',  label: 'GPT-4o',            sub: 'OpenAI · Balanserad',       color: '#10b981' },
];


export const DEFAULT_BRAND_GUIDELINES =
`# Vårdväskan Brand Guidelines

## Mission & Vision
Mission: Möjliggöra personligt uttryck och yrkesstolthet inom vården.
Vision: Att varje vårdprofessionell ska se fram emot att gå till jobbet – med utrustning som kombinerar funktion, stil och glädje.

## Core Values
1. Färg & Glädje - Vi för in färg i vårdens vardag
2. Funktion & Kvalitet - Produkter som håller hela skiftet
3. Personligt Uttryck - Du är unik, din stil också
4. Community - Vi värnar om vårdpersonalens välmående
5. Hållbarhet - För en bättre planet och framtid

## Målgrupp
Sjuksköterskor, undersköterskor, läkare, tandvårdspersonal och omsorgspersonal som värdesätter både professionalism och personlig stil i sitt arbete.

## Ton & Röst
- Varm & Stöttande (vi förstår din arbetsvardag)
- Professionell men Personlig (aldrig stel)
- Inspirerande (produkter ger energi och yrkesstolthet)
- Praktisk (verklig nytta, inte fluff)

## Voice Characteristics
- Direkt tilltal: du/dig
- Aktiv röst ("Tunikan ger dig" inte "Du får av tunikan")
- Konkret & specifik (12-timmars skift, inte "långa dagar")
- Empatisk förståelse (trötta fötter, långa pass)
- Varm och äkta ton utan kampanjspråk

## Balans per Produkttyp
- Arbetskläder: 50% funktion, 30% känsla/stil, 20% community
- Stödstrumpor: 50% hälsoeffekt, 30% komfort, 20% kvalitet

## ANVÄND
arbetsvardag, skift, pass, ronder, vård, omsorg, rörelsefrihet, komfort, stöd, dämpning, ventilerande, hållbar, pålitlig, långsiktig, tålig, färg, stil, uttryck, favorit, unik, kollegor, populär bland, ansvarsfull, miljömedveten

## UNDVIK
Medicinsk jargong (om ej relevant), fashion-termer (trendig, must-have), överdrifter (revolutionerande, bäst i världen), stela fraser (härmed, vänligen), klichéer (next level, game-changer), hashtags, kampanjfraser

VIKTIGT: Använd "fyrvägsstretch" INTE "fyrvägssträck"`;

export const DEFAULT_CATEGORY_TEMPLATES = {
  Stödstrumpor:
`## STEG 1: HOOK (35-45 ord)
Öppna med en konkret, empatisk mening som sätter produkten i ett verkligt vårdsammanhang.
Formel: [Produktnamn] ger dina ben det stöd de [behöver/förtjänar] under [specifik arbetssituation]. [Kompressionsklass + effekt], medan [komfortfeature] håller dig bekväm hela dagen.

Exempel: "Rehband QD ger dina ben det stöd de förtjänar under långa vårdpass. Kompressionsklass II (20-30 mmHg) stimulerar cirkulationen och minskar trötthetskänslan – perfekt för dig som står och går hela arbetsdagen."

## STEG 2: FÖRDELAR (70-90 ord)
Skriv 4-5 korta, naturliga meningar som löper efter varandra – INTE en lista med fetstilta rubriker. Varje mening tillför något nytt: cirkulationseffekt, komfort, passform, diskrethet, hållbarhet. Tänk som en riktig copywriter: variation i meningsbyggnad, inga "Rubrik – förklaring av rubriken"-mönster.

Exempel på rätt ton: "Graduerad kompression håller benen pigga när du inte kan sitta ner. Det höga bomullsinnehållet andas och känns mjukt mot huden även efter tolv timmar. Diskret nog att försvinna under alla arbetskläder – och hållbar nog att hålla formen tvätt efter tvätt."

## STEG 3: PRODUKTBESKRIVNING (100-120 ord)
Tillför ENBART ny information som inte nämndes i Steg 2. Fokus på:
- Materialtekniken: varför bomull + elastan-kombinationen fungerar för vård (andning, fukttransport, rörlighet)
- Anatomisk konstruktion: förstärkt häl och tå, anatomisk fot — vad det faktiskt innebär för bäraren
- Hållbarhet: vad som gör att kompressionen sitter kvar efter upprepad tvätt, till skillnad från billigare alternativ
- Ett konkret användningsscenario (operation, hembesök, ronder) — max två meningar
Ingen upprepning av cirkulationseffekter från Steg 2.

## STEG 4: SPECIFIKATIONER (35-45 ord)
Skriv som ren text, ett fält per rad, utan backticks, utan code-block:
Kompressionsklass: [klass + mmHg]
Material: [sammansättning]
Längd: Knähög
Storlekar: [range]
Tvätt: [instruktion]

## STEG 5: AVSLUTNING (25-30 ord)
En varm, äkta mening som rekommenderar produkten. Ingen lista, inga kampanjfraser, inga brand-slogans.
Exempel: "Investera i dina ben – de bär dig genom varje arbetsdag."

TOTALT: 200-400 ord. Plain text only.`,

  Arbetskläder: '',
  Arbetsskor: '',
};
